<template>
  <div>
    <Loader :flag="flag.isLoading" >
      <div v-if="request && request.reservation && !flag.isLoading">
        <div>
          <div class="d-flex align-items-center mb-2">
            <!-- 迎車日時 -->
            <div
              :class="s.datetime">{{ request.reservation.datetime ? formatTimestamp(request.reservation.datetime, 'YYYY/MM/DD HH:mm') : '即時' }}</div>
            <!-- 予約車氏名 -->
            <div class="fw-bold fs-sm ms-2">{{ request.reservation.user.username }} 様</div>
          </div>
          <Route
            class="mt-1"
            :locations="request.reservation"/>
        </div>
        <div :class="s.btns">
          <large-btn
            @click="updateRequest(21)"
            color="red">拒否</large-btn>
          <large-btn
            @click="updateRequest(11)">了解</large-btn>
        </div>
      </div>
    </Loader>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cf from '@/mixins/commonFunctions.js';
import LargeBtn from './LargeBtn.vue';
import Route from './Route.vue';
import Loader from './Loader.vue';

export default {
  name: 'notice',
  mixins: [cf],
  props: ['requestId'],
  components: {
    Route,
    LargeBtn,
    Loader,
  },
  data() {
    return {
      flag: {
        isLoading: false,
      },
    };
  },
  computed: {
    ...mapState(['user', 'notice']),
  },
  watch: {
    requestId: {
      handler() {
        this.getReservationDetail();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    closeNotice() {
      const args = { name: '' };
      this.$store.dispatch('notice/setNotice', args, { root: true });
    },
    updateRequest(flag) {
      const data = {
        user_id: this.user.id,
        request_id: this.requestId,
        from_user_type: 'driver',
        flag,
      };
      this.axios({
        method: 'POST',
        url: '/v1/request/update',
        data,
      })
        .then((response) => {
          const res = response.data;
          if (res.message === 'Already created order.') {
            alert('他のドライバーが、この配車を承認しているため、処理できませんでした。');
            this.$store.dispatch('user/update', null, { root: true });
            return;
          }
          this.$store.dispatch('user/setRequests', this.user);
          this.$store.dispatch('user/setOrders', this.user);
          if (this.notice.name !== 'reservation-confirmed') this.closeNotice();
          if (flag === 11) this.$router.push('/order/');
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          console.log(error);
        })
        .finally(() => {
          this.$store.dispatch('user/update');
        });
    },
    getReservationDetail() {
      if (!this.requestId) return;

      this.flag.isLoading = true;
      this.axios({
        method: 'GET',
        url: '/v1/request/get/detail',
        params: { id: this.requestId },
      })
        .then((response) => {
          const res = response.data;
          this.request = res.detail;
          if (!this.request) this.closeNotice();
          this.flag.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" module="s">
.datetime {
  padding: 2px 6px;
  border: 1px solid var(--bs-blue);
  color: var(--bs-blue);
  display: inline-block;
  font-size: 12px;
  font-weight: bold;
}
.btns {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  > * {
    width: calc((100% - 12px) / 2);
  }
}
.close {
  font-size: 12px;
  color: var(--label-secondary);
  border-bottom: 1px solid var(--label-secondary);
}
</style>
